<template>
	<label class="sk-switch" :style="{ width: width, maxWidth: width }">
		<input
			type="checkbox"
			@click="updateModel"
			:checked="model"
			:disabled="disabled"
		/>
		<span class="slider round"></span>
	</label>
</template>

<style scoped>
.sk-switch {
	position: relative;
	display: inline-block;
	width: 40px;
	min-height: 20px;
	height: 100%;
	align-self: center;
	margin-bottom: 0;
}

.sk-switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

.slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: var(--sk-grey2);
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

.slider:before {
	position: absolute;
	content: "";
	height: 14px;
	width: 14px;
	left: 4px;
	background-color: var(--gR-white);
	transition: 0.4s;
	top: 50%;
	transform: translateY(-50%);
}

.sk-switch input:checked + .slider {
	background-color: var(--sk-green);
}

.sk-switch input:checked + .slider:before {
	left: calc(100% - 14px - 4px);
}

.sk-switch .slider.round {
	border-radius: 34px;
}

.sk-switch .slider.round:before {
	border-radius: 50%;
}
</style>

<script>
export default {
	name: "SkToggle",
	props: {
		value: {
			type: [Boolean, Number]
		},
		disabled: {
			type: [Boolean, Number]
		},
		width: {
			type: String,
			default: "40px"
		}
	},
	computed: {
		model: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit("input", val)
			}
		}
	},
	methods: {
		updateModel(event) {
			event.preventDefault()
			this.model = !this.model
		}
	}
}
</script>